// extracted by mini-css-extract-plugin
export default {"buttons":"recipeDetails_buttons__W1+S-","active":"recipeDetails_active__8Fhhs","ul_container":"recipeDetails_ul_container__9Td5b","step_li":"recipeDetails_step_li__JQ6QG"};